import { useState } from "react";
/** A refreshable detail URL. Browser Back restores the previous list. */
export function useDetailRecord<T extends { id: string }>(records: readonly T[], key = "provider") {
  const [choice, setChoice] = useState<T | null | undefined>(undefined);
  const id = new URLSearchParams(window.location.search).get(key);
  const selected =
    choice === undefined ? (records.find((record) => record.id === id) ?? null) : choice;
  function select(record: T | null) {
    const url = new URL(window.location.href);
    if (record) url.searchParams.set(key, record.id);
    else url.searchParams.delete(key);
    window.history.pushState({}, "", url.pathname + url.search);
    setChoice(record);
    window.scrollTo({ top: 0 });
  }
  return [selected, select] as const;
}
